import Moment from "moment";

export const localToUtc = (date: string) =>
  Moment(
    Moment(date)
      .local()
      .format("YYYY-MM-DDTHH:mm")
  )
    .utc()
    .format();

export const utcToLocal = date =>
  Moment.utc(date)
    .local()
    .format("YYYY-MM-DDTHH:mm");
